import { useState } from 'react';
import Layout from '../components/Layout';
import client from '../api/client';

export default function PlaceRanking() {
  const [url, setUrl] = useState('');
  const [keyword, setKeyword] = useState('');
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const s: any = {
    card: { background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 8, padding: 20, marginBottom: 16 },
    input: { width: '100%', background: '#0F1117', border: '0.5px solid #2A3045', borderRadius: 8, padding: '10px 14px', color: '#E8ECF4', fontSize: 13, boxSizing: 'border-box' as const },
    btn: { background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 28px', color: '#0A1F18', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
    label: { color: '#B0BAC8', fontSize: 12, marginBottom: 6, display: 'block' },
  };

  const handleSearch = async () => {
    if (!url || !keyword) return alert('URL과 키워드를 입력하세요');
    setLoading(true);
    try {
      const res = await client.post('/place-rank/search', { place_url: url, keyword });
      setResult(res.data);
    } catch { alert('조회 실패'); }
    finally { setLoading(false); }
  };

  const rankColor = (rank: number | null) => rank ? (rank <= 10 ? '#00D4AA' : rank <= 20 ? '#F6AD55' : '#E8ECF4') : '#F56565';

  return (
    <Layout>
      <div style={{ maxWidth: 900 }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ color: '#E8ECF4', fontSize: 18, fontWeight: 700 }}>플레이스 순위 조회</div>
          <div style={{ color: '#8892A4', fontSize: 12, marginTop: 4 }}>키워드 검색 시 내 플레이스가 몇 위에 노출되는지 확인합니다 (상위 30위 이내)</div>
        </div>

        <div style={s.card}>
          <label style={s.label}>네이버 플레이스 URL</label>
          <input style={{ ...s.input, marginBottom: 12 }} value={url} onChange={e => setUrl(e.target.value)}
            placeholder="https://map.naver.com/p/entry/place/..." />
          <label style={s.label}>검색 키워드</label>
          <input style={{ ...s.input, marginBottom: 16 }} value={keyword} onChange={e => setKeyword(e.target.value)}
            placeholder="예: 전주카페, 강남 맛집" onKeyDown={e => e.key === 'Enter' && handleSearch()} />
          <button style={s.btn} onClick={handleSearch} disabled={loading}>{loading ? '조회 중...' : '순위 조회'}</button>
        </div>

        {result && (
          <>
            {/* 순위 결과 */}
            <div style={{ ...s.card, border: result.found ? '1px solid #00D4AA44' : '0.5px solid #2A3045' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <div style={{ textAlign: 'center' as const, minWidth: 100 }}>
                  <div style={{ fontSize: 48, fontWeight: 900, color: rankColor(result.rank), lineHeight: 1 }}>
                    {result.rank_display}
                  </div>
                  {result.rank && <div style={{ color: '#8892A4', fontSize: 11, marginTop: 4 }}>/ {result.total_results?.toLocaleString()}개 중</div>}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ color: '#E8ECF4', fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
                    {result.found ? result.name : '검색 결과에 없음'}
                  </div>
                  {result.found && (
                    <div style={{ display: 'flex', gap: 16 }}>
                      <span style={{ color: '#8892A4', fontSize: 12 }}>⭐ 방문리뷰 {result.visitor_review}</span>
                      <span style={{ color: '#8892A4', fontSize: 12 }}>✍️ 블로그리뷰 {result.blog_review}</span>
                      {result.save_count && <span style={{ color: '#8892A4', fontSize: 12 }}>💾 저장 {result.save_count}</span>}
                    </div>
                  )}
                  {!result.found && (
                    <div style={{ color: '#F56565', fontSize: 12 }}>
                      상위 30위 내에 해당 플레이스가 없습니다. 키워드 최적화가 필요합니다.
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* 상위 30위 목록 */}
            <div style={s.card}>
              <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 700, marginBottom: 16 }}>
                "{keyword}" 상위 {result.items?.length}위 목록
              </div>
              <div style={{ overflowX: 'auto' as const }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' as const }}>
                  <thead>
                    <tr style={{ background: '#1A2035' }}>
                      <th style={{ padding: '8px 12px', color: '#8892A4', fontSize: 11, textAlign: 'left' as const, width: 50 }}>순위</th>
                      <th style={{ padding: '8px 12px', color: '#8892A4', fontSize: 11, textAlign: 'left' as const }}>업체명</th>
                      <th style={{ padding: '8px 12px', color: '#8892A4', fontSize: 11, textAlign: 'right' as const }}>방문리뷰</th>
                      <th style={{ padding: '8px 12px', color: '#8892A4', fontSize: 11, textAlign: 'right' as const }}>블로그리뷰</th>
                    </tr>
                  </thead>
                  <tbody>
                    {result.items?.map((item: any) => {
                      const isMe = item.id === result.items?.find((_: any, i: number) => i + 1 === result.rank)?.id && item.rank === result.rank;
                      return (
                        <tr key={item.rank} style={{ borderBottom: '0.5px solid #1E2535', background: item.rank === result.rank ? '#00D4AA11' : 'transparent' }}>
                          <td style={{ padding: '8px 12px', color: item.rank === result.rank ? '#00D4AA' : '#8892A4', fontSize: 13, fontWeight: item.rank === result.rank ? 700 : 400 }}>
                            {item.rank === result.rank ? '★ ' : ''}{item.rank}
                          </td>
                          <td style={{ padding: '8px 12px', color: item.rank === result.rank ? '#00D4AA' : '#E8ECF4', fontSize: 13, fontWeight: item.rank === result.rank ? 700 : 400 }}>
                            {item.name}{item.rank === result.rank ? ' (내 플레이스)' : ''}
                          </td>
                          <td style={{ padding: '8px 12px', color: '#8892A4', fontSize: 12, textAlign: 'right' as const }}>{item.visitorReview}</td>
                          <td style={{ padding: '8px 12px', color: '#8892A4', fontSize: 12, textAlign: 'right' as const }}>{item.blogReview}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}
